import React, { useContext } from "react";
import NavigationLabel from "./NavigationLabel";
import { Drawer, DrawerOverlay, DrawerContent, DrawerBody, Box } from "@chakra-ui/react";
import { Constants } from "../constants";
import { useLocation } from "react-router-dom";
import { NeedHelp } from "../../common/general";
import { sendTrackingEvent } from "../utils/gtm";

import { AppContext } from "../../../context/ApplicationContext";
import { isProgramPresent } from "../utils/isProgramPresent";

type LabelType = "primary" | "secondary" | "tab" | "hamburger-label";

interface Props {
  isOpen: boolean;

  onClose: () => void;
  labelsList: {
    key: number | string;
    title: string | number;
    type: LabelType;
    badgeComponent?: React.ReactElement; // completely optional
    path: string;
    link?: string;
    isExternal?: boolean;
  }[];
}

const HamburgerMenu = ({ labelsList, isOpen, onClose }: Props) => {
  const location = useLocation();
  const state = useContext(AppContext)[0];
  const handleSendEvent = (title: string | number) => {
    switch (title) {
      case "Referral Program":
        sendTrackingEvent({ event: "dash-referral_program", eventLabel: location.pathname });
        break;
      case "Documents":
        sendTrackingEvent({ event: "dash-candidate_documents", eventLabel: location.pathname });
        break;
      case "PAP":
        sendTrackingEvent({ event: "dash-isa", eventLabel: location.pathname });
        break;
      case "FAQs":
        sendTrackingEvent({ event: "dash-faqs", eventLabel: location.pathname });
        break;
      default:
        return;
    }
  };
  return (
    <Drawer autoFocus={false} size={"full"} isOpen={isOpen} placement="left" onClose={onClose}>
      <DrawerOverlay mt={Constants.headerHeight} />
      <DrawerContent boxShadow={"none"} mt={Constants.headerHeight}>
        <DrawerBody>
          <Box>
            {labelsList.map((label) => (
              <Box
                key={label.key}
                onClick={() => {
                  handleSendEvent(label.title);
                }}
                display={
                  (label.path.includes("isa") &&
                    isProgramPresent("scholar", state.profileData?.programs)) ||
                  (label.path.includes("isa") &&
                    isProgramPresent("cap", state.profileData?.programs)) ||
                  (label.path.includes("isa") && state.isScholar)
                    ? // hide ISA for scholar, CAP program
                      "none"
                    : "block"
                }
              >
                <NavigationLabel
                  title={label.title}
                  type={label.type}
                  active={label.path === location.pathname}
                  path={label.path}
                  badgeComponent={label.badgeComponent}
                  link={label.link}
                  isExternal={label.isExternal}
                />
              </Box>
            ))}
          </Box>
          <Box mt={"ms-16"}>
            <NeedHelp link="https://zoom.us/meeting/register/tJMlfu-prTIqE9C1Ol8PyAxAmDQDbV6BtCD-" />
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default HamburgerMenu;
